import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDataTable,{attrs:{"headers":_setup.cabecalhos,"items":_setup.props.horarios,"dense":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.horario",fn:function({item}){return [_vm._v("\n    "+_vm._s(String(item.horario).substring(0, 5))+"\n  ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }